module.exports = __webpack_public_path__ + "static/media/air_ceiling_4.646f8f11.png";